import React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { useMessageSelectedContext } from '~/components/common/chat/ChatPagesContainer';
import { useMessages } from '~/hooks/deals/useMessages';
import { ChatMessageArea } from '~/components/common/chat/messages/ChatMessageArea';
import { useDeals } from '~/hooks/useDeals';
import { useMessageSummaries } from '~/hooks/useMessageSummaries';
import { ChatPostArea } from '~/components/common/chat/post/ChatPostArea';
import { getUnreadCount } from '~/models/Message';

type Props = DeepReadonly<{
  setIsDisabledUnreadButton: (value: boolean) => void;
}>;

/**
 * チャット画面のメッセージ一覧
 *
 * @for client
 * @constructor
 */
export const ChatMessagePaneBodyClient: React.FC<Props> = ({
  setIsDisabledUnreadButton
}: Props) => {
  const { selectedSummary } = useMessageSelectedContext();
  const { mutate: mutateMessageSummaries } = useMessageSummaries().index();
  const { data: messages, mutate: mutateMessages } = useMessages().index(
    selectedSummary?.deal.id ?? null
  );
  const { data: deal, mutate: mutateDeal } = useDeals().show(
    selectedSummary?.deal.id ?? null
  );

  // const debounce = useDebounce(2000);
  React.useEffect((): void => {
    if (selectedSummary == null) {
      return;
    }
    // debounce(() => {
    mutateDeal?.().then();
    setIsDisabledUnreadButton(true);
    mutateMessages?.().then();
    if (messages) {
      setIsDisabledUnreadButton(
        getUnreadCount(messages, 'maintenance_company') > 0
      );
    }
    // });
  }, [
    selectedSummary,
    mutateMessages,
    mutateDeal,
    setIsDisabledUnreadButton,
    messages
  ]);
  const handleMutate = React.useCallback(async (): Promise<void> => {
    mutateDeal?.().then();
    mutateMessages?.().then();
    mutateMessageSummaries?.().then();
  }, [mutateDeal, mutateMessages, mutateMessageSummaries]);
  if (messages === null || deal === null) {
    return null;
  }
  return (
    <>
      <ChatMessageArea
        deal={deal}
        handleMutate={handleMutate}
        isOpen
        messages={messages}
        speaker="maintenance_company"
      />
      <ChatPostArea deal={deal} handleMutate={handleMutate} />
    </>
  );
};
